import {SoopTitle, SoopButtonIcon} from '@soop-ui/soop-ui';
import styles from './ChatbotHeader.module.scss';

interface ChatbotHeaderProps {
  handleCloseButton: () => void;
  hasHeaderShadow: boolean;
}

const ChatbotHeader = ({
  handleCloseButton,
  hasHeaderShadow,
}: ChatbotHeaderProps) => {
  return (
    <div
      className={`${styles.wrapper} ${hasHeaderShadow ? styles.scrolled : ''}`}>
      <SoopTitle align='center' size='md'>
        SOOP고객센터 숲덕이
      </SoopTitle>
      <SoopButtonIcon
        className={styles.close}
        iconName='icoClose'
        onClick={handleCloseButton}
        size={40}
        variant='clearPrimary'
      />
    </div>
  );
};

export default ChatbotHeader;
